import React from "react";
import faceImage from "../../../../assets/images/FaceLiveness1.png";
const FaceScanInstructions = ({ onStartRecording }) => {
    const handleStartRecording = () => {
        console.log("Start Recording button clicked");
    };

    return (
        <div className="tw-flex tw-flex-col tw-py-5 tw-w-[80%] tw-items-center tw-justify-center ">
            <div></div>
            <div className="tw-w-full">
                <h2 className="tw-text-xl tw-font-semibold tw-mb-4">Record Your Face Scan</h2>

                <div className="tw-flex tw-justify-center tw-items-center tw-mb-6">
                    <div className="tw-relative tw-w-full tw-h-64 tw-border-2 tw-bg-white tw-border-dashed tw-py-5  tw-rounded-lg">
                        <img src={faceImage} alt="Face Guide" className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-contain" />
                    </div>
                </div>
                <div className="tw-flex tw-justify-center">
                    <button onClick={onStartRecording} className="tw-bg-teal-500 tw-text-white  tw-px-6 tw-py-2 tw-rounded hover:tw-bg-teal-600">
                        Start Recording
                    </button>
                </div>
                <div className="tw-text-gray-600 tw-text-sm tw-mt-5">
                    <p className="tw-font-semibold">Instructions:</p>
                    <ul className="tw-list-disc tw-list-inside">
                        <li>Position your face within the oval guide.</li>
                        <li>When ready, tap 'Start Recording'.</li>
                        <li>Slowly turn your head from left to right.</li>
                        <li>Recording will stop automatically after 5 seconds.</li>
                    </ul>
                </div>
                {/* <p className="tw-text-sm tw-text-blue-500 tw-underline tw-cursor-pointer tw-mb-6">
                    Help Section: What to do if the camera isn’t working or if you prefer to upload an existing photo?
                </p> */}
            </div>
            <div></div>
        </div>
    );
};

export default FaceScanInstructions;
